import {request} from '../helpers/request'
import {getSourceNameAndCc} from '../helpers/getSourceData'
import React from 'react';
import Select from 'react-select';
import '../../node_modules/react-select/dist/react-select.css'
import {t} from '../helpers/translate'
import LoadingComponent from './common/LoadingComponent'
import ModalComponent from './common/ModalComponent'
let config = require('config');

class Upload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sourceFullName: null,
      data: '',
      options: [],
      cc_email: '',
      email: 'no-reply@noemail.com',
      url: `${config.default.api}/bulkupload/`+props.params.source+`/csv`,
      uploading: false,
      showModal: false,
    }
  }

  componentWillMount() {
    getSourceNameAndCc(this.props.params.source, this);
  }

  showModal(body) {
    this.setState({
      showModal: true,
      modalBody: t(body)
    })
  }

  displayErrors(err) {
    return err.hasOwnProperty('key') ? err.message : err;
  }

  saveResponseData(data, statusCode) {
    if (statusCode === 500) {
      this.showModal(t('Please upload a valid CSV'));
    } else if (statusCode !== 200) {
      this.showModal(data.messages.map((err) => <p>{this.displayErrors(err)}</p>));
    } else {
      this.showModal(t('An Email will be sent shortly with the results'));
    }

    this.setState({
      uploading: false,
      showModal: true,
      data: '',
      cc_email: ''
    });
    this.inputFile.value = '';
    this.inputText.value = '';
  }

  sendData() {
      this.setState({uploading:true});
      let data = {
        info: this.state.data,
        option: this.state.options.join(','),
        cc_email: this.state.cc_email.replaceAll(' ', ''),
        email: this.state.email.replaceAll(' ', ''),
        partial_skip_validation: config.default.clients[this.props.params.source].partial_skip_validation
      };
      request(this.state.url, 'POST', data, this.saveResponseData.bind(this));
  }

  loadFile(event) {
    event.preventDefault();

    let files;
    if (event.dataTransfer) {
      files = event.dataTransfer.files;
    } else if (event.target) {
      files = event.target.files;
    }
    let reader = new FileReader();
    reader.onload = (function() {
        this.setState(
          {
            data: reader.result
          }
        )
    }.bind(this));

    reader.readAsText(files[0], 'UTF-8');
  }

  setOption (e) {
    if(e.target.checked){
      this.state.options.push(e.target.value)
      return
    }
    this.state.options = this.state.options.filter(item => item !== e.target.value)
  }

  setRadioOption(e){
    this.state.options = [e.target.value]
  }

  updateEmail(event) {
    this.setState({
      cc_email: event.target.value
    });
  }

  renderCheckboxOptions(){
    return <div className="email-options">
        {config.default.clients[this.props.params.source].upload_path[0].options.map((option, i) =>
          <span>
            <input type="checkbox" id={option.value} value={option.value} onChange={this.setOption.bind(this)}/>
            <label className="email-option" htmlFor={option.value}>{option.label}</label>
          </span>
        )}
      </div>
  }

  renderRadioOptions(){
    return <div onChange={this.setRadioOption.bind(this)}>
        {config.default.clients[this.props.params.source].upload_path[0].options.map((option, i) =>
            <div key={i} className="radio-inline">
                <input type="radio" value={option.value} name="radioUpload" id={option.value}/>
                <label className="email-option" htmlFor={option.value}>{option.label}</label>
            </div>
          )
        }
      </div>
  }

  renderOptions(){
    return config.default.clients[this.props.params.source].upload_path[0].radioButtons ? this.renderRadioOptions() : this.renderCheckboxOptions()
  }

  handleModalClose(){
    this.setState({showModal: false});
  }

  render() {
    const url = `${config.default.api}/sources/`;

    return (<div className="container">
      <div className="text-center page-title">
        <h2>{t('Bulk Upload')}</h2>
        <h3>{this.state.sourceFullName}</h3>
      </div>
      <div className="row">
        <div className="col-md-3"></div>
        <div className="search-box col-md-6">
          <form action={url} method="POST">
            <div id="criteria-form">
              <div className="form-group">
                <label className="text-uppercase">
                  {t('CSV File')}
                </label>
                <div className="div-left">
                  <input type="file" accept=".csv" onChange={this.loadFile.bind(this)} ref={(el) => this.inputFile = el} />
                </div>
              </div>
              <div>
                <label className="text-uppercase">{t('Fulfillment options')}</label>
                {this.renderOptions()}
              </div>
              <div className="form-group">
                <label className="text-uppercase">{t('Email')}</label>
                <div className="div-left">
                  <input className="form-control" type="text" onChange={this.updateEmail.bind(this)} ref={el => this.inputText = el}/>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br />
      <div className="div-center">
        <div className="col-md-12">
          <button className={`btn btn-lg button-secondary ${this.state.uploading ? 'disabled-button' : ''}`} onClick={this.sendData.bind(this)}>
            {t('Upload CSV')}
          </button>
        </div>
      </div>
      <LoadingComponent show={this.state.uploading} text='Processing Upload'/>
      <ModalComponent 
        title={t("Bulk Upload Result")}
        body={this.state.modalBody}
        onClose={this.handleModalClose.bind(this)} 
        show={this.state.showModal}
      />
    </div>);
  }
}

Upload.defaultProps = {};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/Upload.js